import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import LeadForm from "./LeadForm";
import { LEAD_FORMS } from "./leadConfig";

/**
 * Reusable CTA block that opens a schema-driven LeadForm modal for any lead type.
 * variant: "card" (default) | "banner" | "compact" (icon + title only, used on dense pages).
 */
export default function LeadCta({ type = "sale", variant = "card", className = "" }) {
  const [open, setOpen] = useState(false);
  const schema = LEAD_FORMS[type];
  if (!schema) return null;
  const Icon = schema.icon;

  const containerCls = variant === "banner"
    ? "flex flex-col items-start justify-between gap-4 rounded-3xl bg-gradient-to-br from-orange-500 to-orange-600 p-5 text-white shadow-md sm:flex-row sm:items-center sm:p-6"
    : variant === "compact"
      ? "flex items-center justify-between gap-3 rounded-2xl border border-border bg-white p-4 shadow-sm"
      : "flex flex-col items-start justify-between gap-4 rounded-3xl border border-border bg-white p-5 shadow-sm sm:flex-row sm:items-center sm:p-6";

  const iconCls = variant === "banner"
    ? "flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white/20 text-white"
    : "flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-brandblue-light text-brandblue";

  const titleCls = variant === "banner" ? "font-display text-lg font-extrabold text-white sm:text-xl" : "font-display text-base font-extrabold text-navy sm:text-lg";
  const subCls = variant === "banner" ? "mt-1 text-sm text-white/90" : "mt-1 text-sm text-slate-500";
  const btnCls = variant === "banner"
    ? "h-11 w-full shrink-0 rounded-xl bg-white px-4 text-sm font-semibold text-orange-600 hover:bg-white/90 sm:w-auto"
    : "h-11 w-full shrink-0 rounded-xl bg-navy px-4 text-sm font-semibold text-amber-300 hover:bg-navy/90 sm:w-auto";

  return (
    <>
      <div className={`${containerCls} ${className}`} data-testid={`lead-cta-${type}`}>
        <div className="flex min-w-0 items-start gap-3 sm:gap-4">
          <span className={iconCls}><Icon size={20} /></span>
          <div className="min-w-0">
            <h3 className={titleCls}>{variant === "compact" ? schema.cta : schema.title}</h3>
            {variant !== "compact" && <p className={subCls}>{schema.subtitle}</p>}
          </div>
        </div>
        <Button onClick={() => setOpen(true)} className={btnCls} data-testid={`lead-cta-open-${type}`}>
          {schema.cta} <ArrowRight size={14} className="ml-1.5" />
        </Button>
      </div>
      {open && <LeadForm type={type} onClose={() => setOpen(false)} />}
    </>
  );
}
